export default __webpack_public_path__ + "static/Resolve-RegularIta-1fdd5a4abb8a5d50786bd30cd1d4c9b0.woff2";